import { useCollectionState } from 'modules/collection/state';
import { memo, useCallback } from 'react';
import { gtm, selectElement, unselectElement } from 'tracking';
import HeroFilterButtonComponent from '../../../../components/hero-filter-button';

interface FilterButtonProps {
  filterName: string;
}

/**
 * Button for the hero filter component.
 * With memo, only the affected filter button will be re-rendered, if a button is updated,
 * reducing the overall rendering time.
 */
const HeroFilterButton: React.FC<FilterButtonProps> = memo(({ filterName }) => {
  const { appliedFilter, toggleFilter } = useCollectionState();

  const handleToggleFilter = useCallback(() => {
    toggleFilter(filterName);
    gtm(
      (appliedFilter.includes(filterName) ? unselectElement : selectElement)({
        element: ['Hero Filter', filterName],
      })
    );
  }, [appliedFilter, toggleFilter, filterName]);

  return (
    <HeroFilterButtonComponent
      filterName={filterName}
      handleToggleFilter={handleToggleFilter}
      isSelected={appliedFilter.includes(filterName)}
    />
  );
});

HeroFilterButton.displayName = 'HeroFilterButton';

export default HeroFilterButton;
